export default [
  {
    path: '/403',
    component: () => import('@/views/system/exception/403/index.vue'),
  },
];
